import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HomeService } from '../../home/home.service';
import { loginStoreActions, notificationStoreActions, relationshipStoreActions } from '@app/root-store';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { getWorkspacesRequest } from '@app/root-store/workspaces-store/actions';
import { NetworkSetupService } from '../../network-setup/network-setup.service';
import { NetworkSetupNavService } from '../../network-setup-nav/network-setup-nav.service';
import { UserService } from '../../user/user.service';
import { EventNames, EVENTS } from '@app/constants/events.constants';
import { HomeSubjectService } from '@app/modules/home-page/container/home-subject.service';
@Injectable({
  providedIn: 'root',
})
export class FunctionsService {
  subscription = new Subscription();
  functionSubject: BehaviorSubject<any> = new BehaviorSubject('');
  constructor(
    private _homeService: HomeService,
    private _dialog: MatDialog,
    private _router: Router,
    private _toastr: ToastrService,
    private _store: Store,
    private networkSetupNavService: NetworkSetupNavService,
    private networkSetupService: NetworkSetupService,
    private _userService: UserService,
    private homeSubjectService: HomeSubjectService
  ) {}

  /**
   * Method : Start Impersonating
   * Description : Function to start impersonating
   * @param switchToUserId user id we're trying to switch
   * @param switchFromUserId user id of current user
   * @param impersonatingUserName user name we're trying to switch
   * @returns void
   */
  startImpersonating(switchToUserId: number, switchFromUserId: number, impersonatingUserName: string, fromNetworkSetup = false): void {
    this._homeService.startImpersonating(switchToUserId, switchFromUserId).subscribe(
      (result: any) => {
        this.functionSubject.next('');
        if (result?.data.status == 'success') {
          try {
            // show info dialog
            const sharedDialogRef = this._dialog.open(SharedConfirmationDialogComponent, {
              width: '400px',
              data: {
                title: 'Entering Guardian Account',
                materialIcon: 'info',
                text: `You will now start operating ${impersonatingUserName}'s account through the Guardian Permission.`,
                proceedTitle: 'Okay',
              },
              disableClose: true,
            });
            this.subscription.add(
              sharedDialogRef.afterClosed().subscribe((confirmation) => {
                if (confirmation) {
                  if (result?.data.type === UserTypeEnum.Professional) {
                    this._router.navigate(['/home'], { queryParams: { impersonating: 'true' } });
                  } else {
                    this._router.navigate(['/home'], { queryParams: { impersonating: 'true' } });
                  }
                  this.functionSubject.next('reload');
                  this.homeSubjectService.handleFetchChatBoxLoaded(true);
                  this.homeSubjectService.handleFetchMainSideNav(false);
                  this.homeSubjectService.handleFetchSetupData("closed");
                  this._store.dispatch(new loginStoreActions.LoginRequestAction());
                  // graphql network call
                  this._store.dispatch(new relationshipStoreActions.AllRelationships());
                  this._store.dispatch(getWorkspacesRequest());
                  if (fromNetworkSetup) {
                    let events = [{ eventName: EVENTS.network_setup_close }];
                    this.trackEventsInMixPanel(events);
                    this.networkSetupService.handleSetupDataCollection.next([]);
                    this.networkSetupNavService.handleNav(false);
                  }
                }
              })
            );
          } catch (ex) {}
        } else if (result?.data.status == 'In use') {
          try {
            const sharedDialogRef = this._dialog.open(SharedConfirmationDialogComponent, {
              width: '400px',
              data: {
                title: 'Account in use',
                materialIcon: 'info',
                text: `${result.data?.userNameOfAccountUser} is already using the account. Please ask them to exit before you can enter the account.`,
                proceedTitle: 'Okay',
              },
              disableClose: true,
            });
          } catch (error) {}
        }
      },
      (error: any) => {}
    );
  }

  /**
   * Method : Exit Impersonating
   * Description : Function to exit impersonating
   * @params nothing
   * @returns void
   */
  exitImpersonating(): void {
    this._homeService.exitFromImpersonating().subscribe(
      (result: any) => {
        this.functionSubject.next('exit');
        if (result?.data.status == 'success') {
          this._toastr.success('You have switched back to your account successfully');
          // redirect to home page
          if (result?.data.type === UserTypeEnum.Professional) {
            this._router.navigateByUrl('/home');
          } else {
            this._router.navigateByUrl('/home');
          }
          // user network call
          this.homeSubjectService.handleFetchChatBoxLoaded(true);
          this.homeSubjectService.handleFetchMainSideNav(false);
          this.homeSubjectService.handleFetchSetupData("closed");
          this._store.dispatch(new loginStoreActions.LoginRequestAction());
          // graphql network call
          this._store.dispatch(new relationshipStoreActions.AllRelationships());
          this._store.dispatch(getWorkspacesRequest());
          // get all notifications network call
          // this._store.dispatch(new notificationStoreActions.NotificationsRequestAction({}, true));
          // get onboarding status
        }
      },
      (error: any) => {}
    );
  }

  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }
}
